import { useState, useCallback, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import DescriptionIcon from '@material-ui/icons/Description';
import { Flex } from './Flex';
import Uploader from './Uploader';
import Dialog from './Dialog';

const ImporterModal = ({
  className,
  dialogProps,
  title,
  helpLink,
  content,
  onDrop,
  onImport,
  allowClose,
  importText,
  dispatch,
  errorComponent,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const onImportClicked = useCallback(() => {
    if (onImport && selectedFile) {
      onImport(selectedFile);
    }
  }, [selectedFile, onImport]);

  const onFilesDropped = useCallback(
    (files) => {
      const selected = files[0];

      // Hacky way to get around issue with Windows not reporting correct MIME type...
      // See https://github.com/react-dropzone/react-dropzone/issues/276
      if (!/\.csv$/i.test(selected.name)) {
        return;
      }

      setSelectedFile(selected);
      if (onDrop) {
        onDrop(selectedFile);
      }
    },
    [onDrop, selectedFile]
  );

  useEffect(() => {
    if (!dialogProps.open) {
      setSelectedFile(null);
    }
  }, [dialogProps.open]);

  return (
    <Dialog
      className={className}
      open={dialogProps.open}
      onClose={dialogProps.onClose}
      allowClose={allowClose}
      helpLink={helpLink}
      title={title}
      {...dialogProps}
      primaryAction={{
        text: importText || 'Import',
        onClick: onImportClicked,
        disabled: !selectedFile,
      }}
    >
      <>
        {errorComponent}
        <Flex p={3} flexDirection={['column-reverse', 'row']}>
          <Box pr={[0, 3]} pb={[3, 0]}>
            {content}
          </Box>
          <Uploader
            onDrop={onFilesDropped}
            selectedFile={selectedFile}
            dropZoneIcon={DescriptionIcon}
            text="Choose File"
            bottomComponent={({ open }) => (
              <Button
                variant="outlined"
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  open();
                }}
              >
                Choose File
              </Button>
            )}
          />
        </Flex>
      </>
    </Dialog>
  );
};

export default ImporterModal;
